export default __webpack_public_path__ + "static/media/Snd1.f408f0f7.mp3";